<template>
    <Toast />
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card p-mt-2">
                <h3 style="margin-left: 20px">Add New Menu</h3>
                <div class="p-fluid p-formgrid p-grid" style="margin: 20px">
                    <div class="p-fluid p-formgrid p-grid">
                        <!-- Main Menu -->
                        <div class="p-field p-col-12 p-md-4">
                            <label>Menu <span class="p-invalid p-error">*</span></label>
                            <InputText v-model="mainmenus" required maxlength="200" placeholder="Enter Menu"
                                :class="{ 'p-invalid': isSubmitted && !mainmenus }" />
                            <small class="p-invalid p-error" v-if="v$.mainmenus.$error">{{
                                v$.mainmenus.$errors[0].$message
                                }}</small>
                        </div>

                        <!-- Main Menu Route -->
                        <div class="p-field p-col-12 p-md-4">
                            <label>Route </label>
                            <InputText v-model="menuroute" :disabled="mainmenus == ''" maxlength="200"
                                placeholder="Enter Route" />
                        </div>
                        <!-- User Type -->
                        <div class="p-field p-col-12 p-md-4">
                            <label>User Type <span class="p-invalid p-error">*</span></label>
                            <MultiSelect v-model="menuUsertype" :options="usertypeList" required optionLabel="label"
                                optionValue="value" placeholder="Select Users" class="multiselect-custom">
                            </MultiSelect>
                            <small class="p-invalid p-error" v-if="v$.menuUsertype.$error">{{
                                v$.menuUsertype.$errors[0].$message }}
                            </small>
                        </div>

                        <!-- Type of User -->
                        <div class="p-field p-col-12 p-md-4">
                            <label>Type of User</label>
                            <MultiSelect v-model="menuTypeofuser" :disabled="!menuUsertype.includes(3)"
                                :options="typeofuserList" optionLabel="label" optionValue="value"
                                placeholder="Select Users" class="multiselect-custom">
                            </MultiSelect>
                        </div>
                        <!--  Icon Name -->
                        <div class="p-field p-col-12 p-md-4">
                            <label>Icon Name</label>
                            <InputText v-model="profileUrl" placeholder="Enter Icon Name" />
                        </div>

                        <!-- Application Type -->
                        <div class="p-field p-col-12 p-md-4">
                            <label>Application Type
                                <span class="p-invalid p-error"> *</span></label>
                            <div class="p-field-radiobutton p-mr-4">
                                <RadioButton id="app" name="option" :value="1" v-model="applicationType" />
                                <label for="app" class="p-mr-4">App</label>
                                <RadioButton id="mobile" name="option" :value="2" v-model="applicationType" />
                                <label for="mobile" class="p-mr-4">Web</label>
                                <RadioButton id="both" name="option" :value="3" v-model="applicationType" />
                                <label for="both" class="p-mr-4">Both</label>
                            </div>
                        </div>

                        <!-- Horizontal Line -->
                        <hr style="width: 100%" />

                        <!-- Dynamically Added Submenus -->
                        <div class="p-col-12" v-for="(submenu, index) in submenus" :key="index">
                            <div class="p-grid">
                                <div class="p-col-12 p-text-right">
                                    <Button icon="pi pi-times" class="p-button-rounded p-button-black p-button-text"
                                        @click="removeSubmenu(index)" />
                                </div>

                                <!-- Sub-menu -->
                                <div class="p-field p-col-12 p-md-4">
                                    <label>
                                        <span class="p-mr-2">{{ index + 1 }} -</span>Sub-menu</label>
                                    <InputText v-model="submenu.submenu" required maxlength="200"
                                        :placeholder="'Enter Sub-menu ' + (index + 1)" />
                                </div>

                                <!-- Sub-menu Route -->
                                <div class="p-field p-col-12 p-md-4">
                                    <label>Route</label>
                                    <InputText v-model="submenu.submenuroute" required maxlength="200"
                                        placeholder="Enter Route" />
                                </div>

                                <!-- User Type -->
                                <div class="p-field p-col-12 p-md-4">
                                    <label>User Type </label>
                                    <MultiSelect v-model="submenu.usertype" :options="usertypeList" optionLabel="label"
                                        optionValue="value" placeholder="Select Users" class="multiselect-custom">
                                    </MultiSelect>
                                </div>

                                <!-- Type of User -->
                                <div class="p-field p-col-12 p-md-4">
                                    <label>Type of User</label>
                                    <MultiSelect v-model="submenu.typeofuser" :disabled="!submenu.usertype.includes(3)"
                                        :options="typeofuserList" optionLabel="label" optionValue="value"
                                        placeholder="Select Users" class="multiselect-custom">
                                    </MultiSelect>
                                </div>

                                <!--  Icon Name -->
                                <div class="p-field p-col-12 p-md-4">
                                    <label>Icon Name</label>
                                    <InputText v-model="submenu.iconName" placeholder="Enter Icon Name" />
                                </div>
                                <!-- Application Type -->
                                <div class="p-field p-col-12 p-md-4">
                                    <label>Application Type
                                        <span class="p-invalid p-error"> *</span></label>
                                    <div class="p-field-radiobutton p-mr-4">
                                        <RadioButton id="app" name="option" :value="1"
                                            v-model="submenu.applicationType" />
                                        <label for="app" class="p-mr-4">App</label>
                                        <RadioButton id="mobile" name="option" :value="2"
                                            v-model="submenu.applicationType" />
                                        <label for="mobile" class="p-mr-4">Web</label>
                                        <RadioButton id="both" name="option" :value="3"
                                            v-model="submenu.applicationType" />
                                        <label for="both" class="p-mr-4">Both</label>
                                    </div>
                                </div>
                            </div>
                            <!-- Sub-submenus inside submenus -->
                            <div v-if="submenu.subSubmenus && submenu.subSubmenus.length">
                                <div class="p-col-12" v-for="(subSub, subIndex) in submenu.subSubmenus" :key="subIndex">
                                    <div class="p-grid">
                                        <!-- Horizontal Line -->
                                        <hr style="width: 100%" />
                                        <div class="p-col-12 p-text-right">
                                            <Button icon="pi pi-times"
                                                class="p-button-rounded p-button-black p-button-text"
                                                @click="submenu.subSubmenus.splice(subIndex, 1)" />
                                        </div>

                                        <!-- Sub-submenu Fields (Same as Submenu) -->
                                        <div class="p-field p-col-12 p-md-4">
                                            <label>{{ subIndex + 1 }} - Sub-submenu</label>
                                            <InputText v-model="subSub.submenu" required maxlength="200"
                                                :placeholder="'Enter Sub-submenu ' + (subIndex + 1)" />
                                        </div>

                                        <div class="p-field p-col-12 p-md-4">
                                            <label>Route</label>
                                            <InputText v-model="subSub.submenuroute" required maxlength="200"
                                                placeholder="Enter Route" />
                                        </div>

                                        <div class="p-field p-col-12 p-md-4">
                                            <label>User Type </label>
                                            <MultiSelect v-model="subSub.usertype" :options="usertypeList"
                                                optionLabel="label" optionValue="value" placeholder="Select Users"
                                                class="multiselect-custom">
                                            </MultiSelect>
                                        </div>

                                        <div class="p-field p-col-12 p-md-4">
                                            <label>Type of User</label>
                                            <MultiSelect v-model="subSub.typeofuser"
                                                :disabled="!subSub.usertype.includes(3)" :options="typeofuserList"
                                                optionLabel="label" optionValue="value" placeholder="Select Users"
                                                class="multiselect-custom">
                                            </MultiSelect>
                                        </div>

                                        <div class="p-field p-col-12 p-md-4">
                                            <label>Icon Name</label>
                                            <InputText v-model="subSub.iconName" placeholder="Enter Icon Name" />
                                        </div>

                                        <div class="p-field p-col-12 p-md-4">
                                            <label>Application Type
                                                <span class="p-invalid p-error"> *</span></label>
                                            <div class="p-field-radiobutton p-mr-4">
                                                <RadioButton id="app" name="subsub-option" :value="1"
                                                    v-model="subSub.applicationType" />
                                                <label for="app" class="p-mr-4">App</label>
                                                <RadioButton id="mobile" name="subsub-option" :value="2"
                                                    v-model="subSub.applicationType" />
                                                <label for="mobile" class="p-mr-4">Web</label>
                                                <RadioButton id="both" name="subsub-option" :value="3"
                                                    v-model="subSub.applicationType" />
                                                <label for="both" class="p-mr-4">Both</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Sub- subMenu -->
                            <Button label="Add Sub-submenu" icon="pi pi-plus" class="p-button-text"
                                @click="addSubSubmenu(index)" />
                            <!-- Horizontal Line -->
                            <hr style="width: 100%" />
                        </div>

                        <!-- Add Sub-menu Button -->
                        <Button label="Add Sub-menu" icon="pi pi-plus" class="p-button-text" @click="addSubmenu" />
                        <!-- <Button label="Reset" icon="pi pi-refresh" class="p-button-text" @click="resetForm" /> -->
                    </div>

                    <!-- Footer Buttons -->
                    <Button label="Submit" icon="pi pi-check" class="p-button-text p-ml-auto" @click="addMenus"
                        style="width: 90px"></Button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from "../../../service/ApiService";
import useValidate from "@vuelidate/core";
import { required, helpers } from "@vuelidate/validators";

export default {
    data() {
        return {
            v$: useValidate(),
            mainmenus: "",
            menuroute: "",
            menuUsertype: [],
            menuTypeofuser: [],
            applicationType: 1,
            submenus: [],
            subSubmenus: [],
            isSubmitted: false,
            showLoader: true,
            iconName: "",
            usertype: [],
            usertypeList: [
                { label: "Admin", value: 1 },
                { label: "Host User", value: 2 },
                { label: "Law User", value: 3 },
            ],
            typeofuser: [],
            typeofuserList: [
                { label: "Citizen", value: 0 },
                { label: "Police", value: 1 },
                { label: "Employer", value: 2 },
                { label: "Property Owner", value: 3 },
            ],
            submenu: {
                iconName: '',
            },
            profileUrl: "",
            profileImageError: "",
            file: null,
            allowedExtensions: null,
            header_file_type: {
                value: 1,
                label: "Image",
            },
        };
    },
    validations() {
        return {
            mainmenus: {
                required: helpers.withMessage("Please enter Menus", required),
            },
            applicationType: {
                required: helpers.withMessage(
                    "Please select application type",
                    required
                ),
            },
            menuUsertype: {
                required: helpers.withMessage("Please select user type", required),
            },
        };
    },
    ApiService: null,
    created() {
        this.ApiService = new ApiService();
    },
    methods: {
        addSubmenu() {
            this.submenus.push({
                submenu: "",
                submenuroute: "",
                usertype: [],
                typeofuser: [],
                iconName: "",
                applicationType: 1,
            });
        },
        addSubSubmenu(submenuIndex) {
            if (!this.submenus[submenuIndex].subSubmenus) {
                this.submenus[submenuIndex].subSubmenus = [];
            }
            this.submenus[submenuIndex].subSubmenus.push({
                submenu: "",
                submenuroute: "",
                usertype: [],
                typeofuser: [],
                iconName: "",
                applicationType: 1,
            });
        },
        removeSubmenu(index) {
            this.submenus.splice(index, 1);
        },
        async addMenus() {
            this.isSubmitted = true;
            this.v$.$validate();
            if (this.v$.$error) return;

            let formData = new FormData();
            let formattedMenuUsertype = this.menuUsertype.join(",");
            let formattedMenuTypeofuser = this.menuTypeofuser.join(",");

            // Build childModule object with subChildModule inside each submenu
            let formattedChildModule = {};
            this.submenus.forEach((submenu, index) => {
                let formattedSubmenu = {
                    mbj2: submenu.submenu, // Sub-menu name
                    mbj4: 1,
                    mbj5: submenu.usertype.join(","),
                    mbj8: submenu.applicationType,
                    mbj9: submenu.submenuroute,
                    mbj10: submenu.iconName,
                };

                if (submenu.usertype.includes(3)) {
                    formattedSubmenu.mbj6 =
                        submenu.typeofuser.length > 0 ? submenu.typeofuser.join(",") : "0";
                }

                // Handling sub-submenus (subChildModule)
                if (submenu.subSubmenus && submenu.subSubmenus.length > 0) {
                    let formattedSubChildModule = {};
                    submenu.subSubmenus.forEach((subsub, subIndex) => {
                        formattedSubChildModule[subIndex] = {
                            mbj2: subsub.submenu, // Sub-submenu name
                            mbj4: 1,
                            mbj5: subsub.usertype.join(","),
                            mbj8: subsub.applicationType,
                            mbj9: subsub.submenuroute,
                            mbj10: subsub.iconName,
                        };

                        if (subsub.usertype.includes(3)) {
                            formattedSubChildModule[subIndex].mbj6 =
                                subsub.typeofuser.length > 0 ? subsub.typeofuser.join(",") : "0";
                        }
                    });

                    formattedSubmenu.subChildModule = formattedSubChildModule;
                }

                formattedChildModule[index] = formattedSubmenu;
            });

            // Main payload formatting
            formData.append("parantModule", this.mainmenus);
            formData.append("mbj9", this.menuroute);
            formData.append("mbj4", 1);
            formData.append("mbj5", formattedMenuUsertype);

            if (formattedMenuUsertype.split(",").includes("3")) {
                formData.append("mbj6", formattedMenuTypeofuser ? formattedMenuTypeofuser : "0");
            }

            formData.append("mbj7", 0);
            formData.append("mbj8", this.applicationType);
            formData.append("mbj10", this.profileUrl);
            formData.append("childModule", JSON.stringify(formattedChildModule));
            this.showLoaderAddBtn = true;

            try {
                let response = await this.ApiService.insertOrUpdateClientMenus(formData);
                if (response.status == 200) {
                    this.$toast.add({ severity: "success", summary: "Successful", detail: response.message, life: 3000 });
                    this.$router.push("/listing/menus");
                } else {
                    throw new Error(response.message);
                }
            } catch (error) {
                this.$toast.add({ severity: "error", summary: "Error", detail: error.message, life: 3000 });
            } finally {
                this.showLoaderAddBtn = false;
            }
        },

    },
};
</script>
